// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import styles from './HeaderLogo.module.scss';
import AristaMDLogoSrc from './assets/aristamd_logo.svg';

/** @type { React.FC<{ path: string, logoUrl?: string }> } */
const HeaderLogo = (props) => {
  const { path, logoUrl = AristaMDLogoSrc } = props;
  return (
    <div id="header">
      <div className={styles.image_container}>
        <Link to={path}>
          <img
            data-spec-id="subdomain-logo"
            src={logoUrl}
            className="tenant-logo"
            alt="logo"
          />
        </Link>
      </div>
    </div>
  );
};

HeaderLogo.displayName = 'HeaderLogo';

HeaderLogo.propTypes = {
  path: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
};

export default HeaderLogo;
